import { isAuthenticated, isClinicalAdmin } from "@/routers/router-guardians"

const routes = [
  {
    path: "/dashboard/appointments/:id",
    name: "appointment_details",
    component: () => import("@/modules/appointments/pages/appointment-details/AppointmentDetails.vue"),
    props: (route) => ({ appointmentId: route.params.id }),
    beforeEnter(to, from, next) {
      isAuthenticated(to, from, next)
    }
  },
  {
    path: "/dashboard/clinical-appointments/:id",
    name: "clinic-appointment-details",
    component: () => import("@/modules/appointments/pages/clinic-appointment-details/ClinicAppointmentDetails.vue"),
    props: (route) => ({ clinicAppointmentId: route.params.id }),
    beforeEnter(to, from, next) {
      isAuthenticated(to, from, next)
    }
  },
  {
    path: "/dashboard/appointments-list",
    name: "appointments_list",
    component: () => import("@/modules/appointments/pages/appointments-list/AppointmentsList.vue"),
    beforeEnter(to, from, next) {
      isAuthenticated(to, from, next)
    }
  },
  {
    path: "/dashboard/encounters",
    name: "encounters",
    component: () => import("@/modules/appointments/pages/encounters-list/EncountersList.vue"),
    beforeEnter(to, from, next) {
      isAuthenticated(to, from, next)
    }
  },
  {
    path: "/dashboard/appointment-requests",
    name: "appointment-requests",
    component: () => import("@/modules/appointments/pages/appointment-requests-list/AppointmentRequests.vue"),
    beforeEnter(to, from, next) {
      isClinicalAdmin(to, from, next)
    }
  }
]

export default routes
